lmApp
  .controller('SubscribersController', ['$routeParams', '$location', '$scope', '$rootScope', '$filter', '$q', '$templateCache', '$compile', '$timeout', 'OperatorRsc', 'MetadataService', 'SubscriberService', 'SubscriptionResource', 'DeviceResource', 'AssetViewingEventResource', 'ModalWindowService', 'ToastService', 'GroupService', 'ValidatorService', 'SubscriberResource', 'ImportService', 'STBModelResource', 'ManagerResource', 'TimezoneService', 'SubscriptionPlanResource', 'SessionResource', 'AssetResource',
    function ($routeParams, $location, $scope, $rootScope, $filter, $q, $templateCache, $compile, $timeout, OperatorRsc, MetadataService, SubscriberService, SubscriptionResource, DeviceResource, AssetViewingEventResource, ModalWindowService, ToastService, GroupService, ValidatorService, SubscriberResource, ImportService, STBModelResource, ManagerResource, TimezoneService, SubscriptionPlanResource, SessionResource, AssetResource) {
      $scope.permissions = $rootScope.permissions;

      $scope.loading = false;
      $scope.searchField = '';
      $scope.subscribers = [];
      $scope.stbModels = {};
      $scope.userCount = -1;

      $scope.collectionData = {
        orderBy: '-create_time',
        limit: 15,
        offset: 0,
        groupFilter: [],
        isStart: function () {
          return $scope.routePage === 1;
        },
        isEnd: false,
        nextPage: function () {
          if (this.isEnd || $scope.loading) return;
          $scope.routePage = $scope.routePage + 1;
          $location.search('page', $scope.routePage);
          this.offset += $scope.collectionData.limit;
          $scope.getSubscribers();
        },
        prevPage: function () {
          if (this.isStart()) return;
          if (this.offset >= this.limit) {
            this.offset -= this.limit;
            $scope.routePage = $scope.routePage - 1;
            $location.search('page', $scope.routePage);
          } else {
            this.offset = 0;
            $scope.routePage = 1;
            $location.search('page', 1);
          }
          $scope.getSubscribers();
        }
      };

      var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});

      OperatorRsc.getCurrentOperator().$promise
        .then(function (result) {
          $scope.operator = result.data;
          if (!$scope.operator) throw result;
          $scope.operator.playback_session_limit = $scope.operator.playback_session_limit || 3;
          return
        })
        .then(function () {
          ManagerResource.get().$promise
            .then(function (result) {
              if (result.length !== 0) {
                var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
                if (manager) {
                  var tz = manager.ui_timezone || 'UTC';
                  timezone = _.find(TimezoneService.Timezones, {title: tz});
                }
              }
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
            });
        })
        .catch(function (reason) {
          $rootScope.debugInfo(reason, 'silent');
          ToastService.Small({
            title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
            color: 'amber',
            icon: 'server-off',
            blocked: true
          }, 1000 * 3);
        });

      $scope.convertTime = function (dt) {
        return TimezoneService.addTimezoneToDate(dt, timezone)
      };

      $scope.nextPage = function () {
        if ($scope.collectionData.offset + $scope.collectionData.limit < $scope.subscribers.length) {
          $scope.collectionData.offset = $scope.collectionData.offset + $scope.collectionData.limit;
        }
      };

      $scope.prevPage = function () {
        $scope.collectionData.offset = Math.max($scope.collectionData.offset - $scope.collectionData.limit, 0);
      };

      $scope.setOrder = function (field) {
        if (field === $scope.collectionData.orderBy) {
          $scope.collectionData.orderBy = '-' + $scope.collectionData.orderBy;
        } else {
          $scope.collectionData.orderBy = field
        }
        $scope.collectionData.offset = 0;
        $scope.routePage = 1;
        $location.search('page', 1);
        $scope.getSubscribers();
      };

      $scope.isCurrentTab = function (user, tab) {
        return user._tab === tab;
      };

      $scope.setCurrentTab = function (user, tab) {
        user._tab = tab;
      };

      var prevParams = {'groups.id[in]': -1, '$match': ''};
      var getSubscribersCount = function(params) {
        var newParams = {
          'groups.id[in]': params['groups.id[in]'],
          '$match': params['$match']
        };
        if ((prevParams['groups.id[in]'] === params['groups.id[in]']) && prevParams['$match'] === params['$match']) {
          return;
        }

        $scope.userCount = -1;
        var offset = 0;
        var limit = 3000;
        var newOffset = limit;

        newParams['$limit'] = 1;
        var findCeilingOffset = function () {
          newParams['$offset'] = newOffset;

          SubscriberResource.get(newParams).$promise
              .then(function (result) {
                var subscribers = (result.data || []);
                if (subscribers.length > 0) {
                  offset = newOffset;
                  newOffset += limit;
                  findCeilingOffset();
                } else {
                  getFinalCount(offset, limit);
                }
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
              })
        };

        var getFinalCount = function(offset, limit) {
          newParams['$limit'] = limit;
          newParams['$offset'] = offset;
          SubscriberResource.get(newParams).$promise
              .then(function (result) {
                var subscribers = (result.data || []);
                $scope.userCount = subscribers.length + offset;
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
              })
        };

        findCeilingOffset();
        prevParams = newParams;
      };

      $scope.getSubscribers = function () {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscribersLoader');

        $scope.collectionData.isEnd = false;

        var params = {};
        params['$limit'] = $scope.collectionData.limit + 1;
        params['$offset'] = $scope.collectionData.offset;
        params['$orderby'] = $scope.collectionData.orderBy;

        if ($scope.searchField !== '') {
          params['$match'] = _.trim($scope.searchField)
        }

        if ($scope.collectionData.groupFilter.length > 0) {
          var ids = [];
          for(var i = 0; i <  $scope.collectionData.groupFilter.length; i++) {
            ids.push($scope.collectionData.groupFilter[i].id);
          }
          params['groups.id[in]'] = ids.join(',')
        }

        getSubscribersCount(params);



        SubscriberResource.get(params).$promise
          .then(function (result) {
            var users = (result.data || []);
            if (users.length < $scope.collectionData.limit + 1) {
              $scope.collectionData.isEnd = true;
            } else {
              users.pop();
            }

            $scope.subscribers = users
              .map(function (user, i) {
                user._tab = 'info';
                user._tabLastActivityVersion = 2;
                user._devices = [];
                user._subscriptions = [];
                user._subscriptionOffset = 0;
                user._subscriptionLimit = 10;
                user._lastActivity = [];
                user._sessions = [];
                user.playback_session_limit = user.playback_session_limit || 0;
                user.pc_pin = user.pc_pin || "0000";
                user.npvr_limit = user.npvr_limit || 0;
                user._name = _.trim((user.first_name || '' ) + ' ' + (user.last_name || '')) || 'N/A';
                user._groups = [];
                if (user.groups && user.groups.length > 0) {
                  user._groups = user.groups.map(function (group) {
                    return {
                      id: group.id,
                      title: group.name
                    }
                  });
                }
              return user;
            });

            if ($scope.subscribers.length === 0 && $scope.routePage !== 1) {
              $scope.collectionData.offset = 0;
              $scope.routePage = 1;
              $location.search('page', 1);
              $scope.loading = false;
              $scope.getSubscribers();
            }

            return $scope.subscribers
          })
          .then(function () {
            GroupService.GetGroups()
              .then(function (collection) {
                $rootScope.hideLinearProgress('#subscribersLoader');

                $scope.groupList = collection.map(function (group) {
                  return {
                    id: group.id,
                    title: group.name
                  }
                });
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason, 'silent');
                ToastService.Small({
                  title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                  color: 'amber',
                  icon: 'server-off',
                  blocked: true
                }, 1000 * 3);
              });
            return
          })
          .then(function () {
            $scope.loading = false;
            STBModelResource.get().$promise
              .then(function (result) {
                result.forEach(function (model) { $scope.stbModels[model.name] = model.id });
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason);
              })
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          })
      };

      var SUBSCRIPTION_STATUS_COLOR = {
        'unpaid':    'amber',
        'cancelled': 'red',
        'trialing':  'green',
        'active':    'green'
      };

      var SUBSCRIPTION_PERIOD = {
        'day': 'Daily',
        'week': 'Weekly',
        'month': 'Monthly',
        'year': 'Annually'
      };

      $scope.getUserSubscriptions = function (user) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        return SubscriptionResource.get({'subscriber.id[eq]': user.id}).$promise
          .then(function (result) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

            user._subscriptionOffset = 0;
            user._subscriptionLimit = 10;
            user._subscriptions = (result.data || [])
              .sort(function (x, y) { return y.id - x.id; })
              .map(function (subscription, i) {
                subscription._isCanceled = !!subscription.cancel_at_period_end;
                subscription._statusColor = SUBSCRIPTION_STATUS_COLOR[subscription.state];
                subscription._periodUnit = SUBSCRIPTION_PERIOD[subscription.plan.period_unit];
                subscription._state = subscription.state.toUpperCase();
                return subscription;
              });
            return user;
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              $rootScope.debugInfo(reason);
            });
        };

      $scope.isSubscriptionActive = function (subscription) {
        return ((subscription.state === 'active' || subscription.state === 'trialing') && !subscription._isCanceled)
      };

      $scope.cancelSubscription = function (user, subscription) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">You are about to cancel the active subscription of the user "' + user.ext_id +'"? Are you sure you want to continue?</span> ';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                return SubscriptionResource.cancelSubscription(subscription).$promise
                  .then(function (result) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

                    var updatedSubscription = result.data.subscription;
                    subscription.state = updatedSubscription.state;
                    subscription._isCanceled = !!updatedSubscription.cancel_at_period_end;
                    subscription._statusColor = SUBSCRIPTION_STATUS_COLOR[updatedSubscription.state];
                    subscription._state = updatedSubscription.state.toUpperCase();
                    ToastService.Small({
                      title: 'The subscription of the user ' + user.ext_id +' was canceled',
                      color: 'green',
                      icon: 'delete'
                    });
                    return subscription;
                  })
                  .catch(function (reason) {
                      var updated = {
                          id: subscription.id,
                          state: 'cancelled',
                      }
                      SubscriptionResource.update(updated).$promise
                          .then(function () {
                              $scope.loading = false;
                              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

                              subscription.state = updated.state;
                              subscription._statusColor = SUBSCRIPTION_STATUS_COLOR[updated.state];
                              subscription._state = updated.state.toUpperCase();

                              ToastService.Small({
                                  title: 'The subscription of the user ' + user.ext_id +' was canceled',
                                  color: 'green',
                                  icon: 'delete'
                              });

                              return subscription;
                          })
                          .catch(function (reason) {
                              $scope.loading = false;
                              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                              $rootScope.debugInfo(reason);
                              ToastService.Small({
                                  title: 'Failed to cancel subscription',
                                  color: 'red',
                                  icon: 'delete'
                              });
                          });
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.getUserLastActivity = function (user) {
        $scope.getUserLastActivityV1(user);
        $scope.getUserLastActivityV2(user);
      };

      $scope.getUserLastActivityV1 = function (user) {
        if (user._tabLastActivityVersion !== 1) {
          return;
        }
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        return AssetViewingEventResource.get({'subscriber.id[eq]': user.id}).$promise
            .then(function (result) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

              user._lastActivity = (result.data || [])
                  .map(function (event, i) {
                    return event;
                  });
              return user;
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              $rootScope.debugInfo(reason);
            });
      };

      var assetResourceTypes = {
          'dvr': 'TV catch-up',
          'hls-catchup': 'TV catch-up',
          'hls-live': 'TV live',
          'hls': 'Video on demand'
      };

      $scope.getUserLastActivityV2 = function (user) {
        if (user._tabLastActivityVersion !== 2) {
          return;
        }
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        var params = {
            'subscriber.id[eq]': user.id,
            '$expand': 'ticket(resource,device)',
            '$orderby': '-last_use_time',
            '$limit': 20
        };

        var currentTime = moment();

        return SessionResource.get(params).$promise
            .then(function (sessions) {
                user._sessions = [];
                if (sessions.length === 0) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                    return;
                }
                var resourceIDs = [];
                for (var i = 0; i < sessions.length; i++) {
                    if (sessions[i].ticket && sessions[i].ticket.resource) {
                        resourceIDs.push(sessions[i].ticket.resource.id);
                    }
                }

                if (!resourceIDs.length) return
                var params = {
                    'resources.id[in]': resourceIDs.join(','),
                    '$expand': 'resources'
                };
                AssetResource.get(params).$promise
                    .then(function (assets) {
                        var resourceIDtoAssetTitle = {};
                        for (var i = 0; i < assets.length; i++) {
                            var asset = assets[i];
                            for (var j = 0; j < asset.resources.length; j++) {
                                resourceIDtoAssetTitle[asset.resources[j].id] = asset.name;
                            }
                        }
                        for (var i = 0; i < sessions.length; i++) {
                            var session = sessions[i];
                            user._sessions.push({
                                contentType: assetResourceTypes[session.ticket.resource.type] || 'N/A',
                                contentTitle: resourceIDtoAssetTitle[session.ticket.resource.id] || 'N/A',
                                sessionStart: session.ticket.create_time,
                                sessionEnd: session.last_use_time,
                                closed: !(!session.ticket.closed && currentTime.diff(moment(session.last_use_time), 'hours') < 3),
                                duration: moment.utc(moment(session.last_use_time).diff(moment(session.ticket.create_time), 'seconds') * 1000).format('HH:mm:ss'),
                                IP: session.ip,
                                deviceOS: session.ticket.device.os,
                                deviceModel: session.ticket.device.model,
                                userAgent: session.ua
                            });
                        }
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                        return;
                    })
                    .catch(function (reason) {
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                        $rootScope.debugInfo(reason);
                    });
                return;
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              $rootScope.debugInfo(reason);
            });
      };

      $scope.getUserInfo = function (user) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        return SubscriberResource.get({'id[eq]': user.id}).$promise
          .then(function (result) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            if (result.data.length === 1) {
              var respUser = result.data[0];
              user = _.extend(user, respUser);
              user.contact_email = respUser.contact_email;
              user.pc_pin = respUser.pc_pin || "0000";
              user.registration_code = respUser.registration_code;
              user.password_reset_code = respUser.password_reset_code;
              user.playback_session_limit = respUser.playback_session_limit || 0;
              user.npvr_limit = respUser.npvr_limit || 0;
              user.groups = respUser.groups || [];
              user._name = _.trim((user.first_name || '' ) + ' ' + (user.last_name || '')) || 'N/A';
              user._groups = [];
              if (user.groups && user.groups.length > 0) {
                user._groups = user.groups.map(function (group) {
                  return {
                    id: group.id,
                    title: group.name
                  }
                });
              }
            }
            return user;
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            $rootScope.debugInfo(reason);
          });
      };

      var isSTBFromSupportedDevicesList = function(device) {
        if (device.model === undefined) {
          return false
        }
        return $scope.stbModels.hasOwnProperty(device.model.toLowerCase());
      };

      $scope.getUserDevices = function (user) {
        return DeviceResource.get({'subscriber.id[eq]': user.id}).$promise
          .then(function (result) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

            user._devices = (result.data || [])
              .sort(function (x, y) { return Boolean(y.stb) - Boolean(x.stb); })
              .map(function (device, i) {
                device._icon = MetadataService.GetPlatformIcon(device.platform);
                device._isSTBFromSupportedDevicesList = isSTBFromSupportedDevicesList(device);
                return device;
              });

            return user;
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            $rootScope.debugInfo(reason);
          });
      };

      $scope.addAsSTB = function(user, device) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        $scope.modalWindowScope = $scope.$new();
        var inner = 'Are you sure that you want to add the <b>"' + device.model +'"</b> model to the list of supported devices?';

        ModalWindowService.Open({
          content: inner,
          actions: [
          {
            title: 'I understand. Do it',
            color: 'green',
            fn: function () {
              STBModelResource.add({name: device.model}).$promise
                .then(function () {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

                  $scope.stbModels[device.model.toLowerCase()] = 11111;
                  for(var i = 0; i < user._devices.length; i++) {
                    user._devices[i]._isSTBFromSupportedDevicesList = isSTBFromSupportedDevicesList(user._devices[i]);
                  }

                  ToastService.Small({
                    title: 'The <b>' + device.model + '</b> model successfully added',
                    color: 'green',
                    icon: 'email-outline'
                  });
                })
                .catch(function (reason) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                    title: 'The operation failed',
                    color: 'red',
                    icon: 'email-outline'
                  });
                });
            }
          },
          {
            title: 'cancel',
            color: 'red',
            fn: function () {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            }
          }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.userSubscriptionsNextPage = function (user) {
        if (user._subscriptionOffset + user._subscriptionLimit < user._subscriptions.length) {
          user._subscriptionOffset = user._subscriptionOffset + user._subscriptionLimit;
        }
      };

      $scope.userSubscriptionsPrevPage = function(user) {
        user._subscriptionOffset = Math.max(user._subscriptionOffset - user._subscriptionLimit, 0);
      };

      $scope.setActiveSubscriber = function (user) {
        if (user.isActive) {
          user.isActive = false;
        } else {
          user.isActive = true;
          $scope.loading = true;
          $rootScope.showLinearProgress('#subscriberLoader' + user.id);

          $scope.getUserInfo(user);
          $scope.getUserDevices(user);
          $scope.getUserSubscriptions(user);
          $scope.getUserLastActivity(user);
        }
      };

      $scope.unsetActiveSubscriber = function (user) {
        user.isActive = false;
      };

      $scope.isActiveSubscriber = function (user) {
        return user.isActive;
      };

      $scope.updateSubscriber = function (user) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        user.validateErrors = {};
        if (!ValidatorService.Pin(user.pc_pin)) {
          user.validateErrors.pc_pin = true;
          user.validateErrors.pinText = 'Invalid PIN format. Allow 4 digits.';
          return
        }
        if (!ValidatorService.Numerical(user.playback_session_limit) || user.playback_session_limit < 0 || user.playback_session_limit > 100) {
          user.validateErrors.playback_session_limit = true;
          user.validateErrors.sessionLimitText = 'Invalid value. Must be >= 0 and <= 100';
          return;
        }
        if (!ValidatorService.Numerical(user.npvr_limit) || user.npvr_limit < 0) {
          user.validateErrors.npvr_limit = true;
          user.validateErrors.npvrLimitText = 'Invalid limit. Must be >= 0';
          return;
        }
        if (user.contact_email && !ValidatorService.Email(user.contact_email)) {
          user.validateErrors.contact_email = true;
          user.validateErrors.contactEmailText = 'Invalid email';
          return;
        }

        SubscriberResource.update(user).$promise
          .then(function () {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            ToastService.Small({
              title: user.ext_id + ' successfully saved',
              color: 'green',
              icon: 'account-box-outline'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: user.ext_id + ' save failed',
              color: 'red',
              icon: 'account-box-outline'
            });
          });
      };

      $scope.SwitchUserBlock = function (user) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        $scope.modalWindowScope = $scope.$new();
        var action = user.blocked ? 'unblock' : 'block';
        var inner = '<span class="heavy">Are you sure you want <b>to ' + action + '</b> the user "' + user.ext_id +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                SubscriberResource.update({id: user.id, blocked: !user.blocked}).$promise
                  .then(function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);

                    user.blocked = !user.blocked;
                    ToastService.Small({
                      title: user.ext_id + ' successfully saved',
                      color: 'green',
                      icon: 'email-outline'
                    });
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: user.ext_id + ' save failed',
                      color: 'red',
                      icon: 'email-outline'
                    });
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.setSubscriberPassword = function(user) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        $scope.modalWindowScope = $scope.$new();
        $scope.modalWindowScope.username = user.ext_id;
        $scope.modalWindowScope.newPassword = '';
        $scope.modalWindowScope.errors = {
          newPassword: ''
        };
        var inner = $compile($templateCache.get('set-subscriber-password.html'))($scope.modalWindowScope);

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              check: function () {
                $scope.modalWindowScope.errors.newPassword = '';
                if (!$scope.modalWindowScope.newPassword) {
                  $scope.modalWindowScope.errors.newPassword = 'Password field cannot be empty';
                } else if (!ValidatorService.Password($scope.modalWindowScope.newPassword)) {
                  $scope.modalWindowScope.errors.newPassword = 'Invalid password format. Min 6 symbols';
                }
                return !$scope.modalWindowScope.errors.newPassword;
              },
              fn: function () {
                SubscriberResource.setPassword({id: user.id, password: $scope.modalWindowScope.newPassword}).$promise
                  .then(function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                    ToastService.Small({
                      title: 'Password successfully changed',
                      color: 'green',
                      icon: 'email-outline'
                    });
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Failed to set user password',
                      color: 'red',
                      icon: 'email-outline'
                    });
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.removeUser = function (user) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#subscriberLoader' + user.id);

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the user "' + user.ext_id +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                SubscriberResource.remove({id: user.id}).$promise
                  .then(function () {
                    user.deleted = true;
                    ToastService.Small({
                      title: 'The user ' + user.ext_id + ' was deleted',
                      color: 'green',
                      icon: 'delete'
                    });
                    var isEmpty = true;
                    for (var i = 0, len = $scope.subscribers.length; i < len; i++) {
                      if (!$scope.subscribers[i].deleted) {
                        isEmpty = false;
                        break;
                      }
                    }
                    if (isEmpty) {
                      $scope.searchField = '';
                    }
                    $scope.loading = false;
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Failed to remove user',
                      color: 'red',
                      icon: 'delete'
                    });
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.importPerform = function () {
        $timeout(function () {
          angular.element('#import_xml').trigger('click');
        });
      };

      $timeout(function () {
        angular.element('#import_xml')
          .on('change', function () {
            $scope.importInProgress = true;
            $scope.loading = true;
            $scope._progress_ = angular.element('#importProgress');
            $scope._bar_ = $scope._progress_.find('.determinate');

            $scope.error = '';
            if (!this.files || !this.files.length) {
              ToastService.Small({
                title: 'Please, choose at least one file',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            var file = this.files[0];

            if (file.type !== 'text/xml') {
              ToastService.Small({
                title: 'File should be in XML format',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            $scope._progress_.css({ 'display': 'block' });

            angular.element('#import_xml').innerHTML =  angular.element('#import_xml').innerHTML;

            ImportService.UploadToCloud(file, $scope._progress_)
              .then(function (response) {
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                ImportService.CreatePerformImport(response.Location)
                  .then(function () {
                    $scope.importInProgress = false;

                    ToastService.Big({
                      title: 'Import will continue in background. Check this page later.',
                      color: 'green',
                      icon: 'arrow-down-bold-hexagon-outline'
                    }, 1000 * 60);
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                  })
                  .then(function () {
                    $scope.loading = false;
                  });
              }, function (reason) {
                $scope.importInProgress = false;
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                $rootScope.debugInfo(reason);
              });
          });
      }, 600);

      var searchWatcher = $scope.$watch('searchField', function (newValue, oldValue) {
        if (newValue != oldValue) {
          $scope.collectionData.offset = 0;
          $scope.routePage = 1;
          $location.search('page', 1);
          $scope.getSubscribers();
        }
      });

      $scope.FilterByGroups = function () {
        $scope.collectionData.offset = 0;
        $scope.routePage = 1;
        $location.search('page', 1);
        $scope.getSubscribers();
      };

      $scope.getXLSXReport = function () {
        if ($scope.operator.ext_id === "nar") {
          return SubscriberService.GetNARSubscriberReport().catch(function (reason) {
            ToastService.Small({
              title: 'Error Exporting Data',
              color: 'red',
              icon: 'server-off'
            }, 1000 * 3);
            $rootScope.debugInfo(reason);
          });
        }
        return SubscriberService.GetSubscriberReport().catch(function (reason) {
          ToastService.Small({
            title: 'Error Exporting Data',
            color: 'red',
            icon: 'server-off'
          }, 1000 * 3);
          $rootScope.debugInfo(reason);
        });
      };

      $scope.getCSVReport = function () {
        return SubscriberService.GetCSVSubscriberReport().catch(function (reason) {
          ToastService.Small({
            title: 'Error Exporting Data',
            color: 'red',
            icon: 'server-off'
          }, 1000 * 3);
          $rootScope.debugInfo(reason);
        });
      };

      if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
        $scope.routePage = Number($routeParams.page);
        $scope.collectionData.offset = ($scope.routePage - 1) * $scope.collectionData.limit;
      } else {
        $scope.routePage = 1;
      }

      $scope.getSubscribers();

      $scope.isCreationAllowed = function () {
        if ($scope.permissions.sections && $scope.permissions.sections.hasOwnProperty('subscribers') && $scope.permissions.sections.subscribers.creation) {
          return true
        }
        return false
      };

      $scope.plans = []

      SubscriptionPlanResource.get({'$expand': ''}).$promise
        .then(function (plans) {
          var planList = [];
          for (var i = 0; i < plans.length; i++) {
              var p = plans[i];
              if (p.state !== 'active') continue
              var processed = {
                  id: p.id,
                  title: p.name,
                  period: p.period_unit,
                  periodCount: p.period,
              };
              planList.push(processed);
          }
          $scope.plans = planList;
        })
        .catch(function (reason) {
          $rootScope.debugInfo(reason, 'silent');
      });

      $scope.addSubscription = function (user) {
        if ($scope.loading) return;

        $scope.newSubscription = {
            user: user,
            username: user.username || user.ext_id,
            plan: {},
            existed: false,
        }
        $scope.newSubscription.plans = angular.copy($scope.plans);
        $scope.newSubscription.rotation_start = moment().utc().startOf('day');
        $scope.newSubscription.rotation_end = moment().utc();

        $scope.subscriptionErrors = {plan: ''};

        var inner = $templateCache.get('new-subscription.tpl.html');
        inner = $compile(inner)($scope);

        $scope.window = ModalWindowService.Open({
            content: inner,
            isFixed: true,
            clear: true,
            keyboard: true,
            actions: [
                {
                    title: 'Create',
                    color: 'green',
                    check: function () {
                        var valid = true
                        $scope.subscriptionErrors.plan = '';
                        if (!$scope.newSubscription.plan.id) {
                            $scope.subscriptionErrors.plan = 'Plan field cannot be empty';
                            valid = false
                        }
                        if ($scope.newSubscription.existed) {
                            valid = false
                        }
                        return valid;
                    },
                    fn: function () {
                        $scope.loading = true;

                        var newSubscription = {
                            subscriber: {id: user.id},
                            plan: {id: $scope.newSubscription.plan.id},
                            state: 'active',
                            period_start_time: $scope.newSubscription.rotation_start.format(),
                            period_end_time: $scope.newSubscription.rotation_end.format(),
                        }

                        SubscriptionResource.create(newSubscription).$promise
                            .then(function (response) {
                                $scope.getUserSubscriptions(user)
                                $scope.loading = false;
                                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                                ToastService.Small({
                                    title: 'The subscription has been created',
                                    color: 'green',
                                    icon: 'refresh'
                                }, 20 * 1000);
                            })
                            .catch(function (reason) {
                                $scope.loading = false;
                                $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                                ToastService.Small({
                                    title: 'Failed to create subscription: ' + _.get(reason, 'data.error.message', 'server error'),
                                    color: 'red',
                                    icon: 'delete'
                                }, 30 * 1000);
                            });
                        }
                    },
                    {
                        title: 'Cancel',
                        color: 'red',
                        fn: function () {
                            $scope.loading = false;
                            $rootScope.hideLinearProgress('#subscriberLoader' + user.id);
                        }
                    }
                ],
                size: {
                    s: 7,
                    l: 5
                }
            });
        };

      $scope.changeSubscriptionPeriod = function (option) {
          $scope.newSubscription.rotation_start = moment().utc().startOf('day');
          $scope.newSubscription.rotation_end = moment().utc().add(option.periodCount, option.period + 's');
          $scope.newSubscription.existed = false

          for (var i = 0, len = $scope.newSubscription.user._subscriptions.length; i < len; i++) {
              var s = $scope.newSubscription.user._subscriptions[i]
              if (s.plan.id === option.id && (s.state === 'trialing' || s.state === 'active')) {
                  $scope.newSubscription.existed = true
              }
          }
      }

      $scope.addSubscriber = function () {
          $scope.newSubscriber = {
              email: '',
              password: '',
              firstName: '',
              lastName: '',
              _errors: {},
          }

          var inner = $templateCache.get('add-subscriber.html');
          inner = $compile(inner)($scope);

          $scope.window = ModalWindowService.Open({
              content: inner,
              isFixed: true,
              clear: true,
              keyboard: true,
              actions: [
                  {
                      title: 'Create',
                      color: 'green',
                      check: function () {
                          $scope.newSubscriber._errors = {};

                          if (!$scope.newSubscriber.email) {
                              $scope.newSubscriber._errors.email = 'Required filed';
                          }
                          if ($scope.newSubscriber.email && !ValidatorService.Email($scope.newSubscriber.email)) {
                              $scope.newSubscriber._errors.email = 'Wrong email format';
                          }
                          if (!$scope.newSubscriber.password) {
                              $scope.newSubscriber._errors.password = 'Password field cannot be empty';

                          } else if (!ValidatorService.Password($scope.newSubscriber.password)) {
                              $scope.newSubscriber._errors.password = 'Invalid password format. Min 6 symbols. a-z 0-9 _ -.';
                          }

                          return _.isEmpty($scope.newSubscriber._errors);
                      },
                      fn: function () {
                          $scope.loading = true;
                          $rootScope.showLinearProgress('#subscribersLoader');

                          var newSubscriber = {
                              ext_id: $scope.newSubscriber.email,
                              username: $scope.newSubscriber.email,
                              first_name: $scope.newSubscriber.firstName,
                              last_name: $scope.newSubscriber.lastName,
                          }

                          SubscriberResource.create(newSubscriber).$promise
                              .then(function (response) {
                                  var user = response.data;

                                  SubscriberResource.setPassword({id: user.id, password: $scope.newSubscriber.password}).$promise
                                      .then(function () {
                                          $scope.loading = false;
                                          $rootScope.hideLinearProgress('#subscribersLoader');

                                          $scope.collectionData.offset = 0;
                                          $scope.routePage = 1;
                                          $location.search('page', 1);
                                          $scope.getSubscribers();

                                          ToastService.Small({
                                              title: 'The subscriber has been created',
                                              color: 'green',
                                              icon: 'refresh'
                                          }, 20 * 1000);
                                      })
                                      .catch(function (reason) {
                                          $scope.loading = false;
                                          $rootScope.hideLinearProgress('#subscribersLoader');
                                          $rootScope.debugInfo(reason);
                                          ToastService.Small({
                                              title: 'Failed to set user password',
                                              color: 'red',
                                              icon: 'email-outline'
                                          });
                                      });
                              })
                              .catch(function (reason) {
                                  $scope.loading = false;
                                  $rootScope.hideLinearProgress('#subscribersLoader');
                                  $rootScope.debugInfo(reason);
                                  ToastService.Small({
                                      title: 'Failed to create subscriber: ' + _.get(reason, 'data.error.message', 'server error'),
                                      color: 'red',
                                      icon: 'delete'
                                  }, 30 * 1000);
                              });
                      }
                  },
                  {
                      title: 'Cancel',
                      color: 'red',
                      fn: function () {
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#subscribersLoader');
                      }
                  }
              ],
              size: {
                  s: 7,
                  l: 5
              }
          });
      }

      $scope.$on('$destroy', function () {
        if (searchWatcher) searchWatcher();
      });
  }]);
